import { Box, Button, Dialog, Theme, Typography } from '@mui/material'
import React from 'react'
import { MAX_SCHEMES_SELECTED } from '../../../../utils/constant'

type Props = {
    handleCloseFiveSchemesDialog: () => void
    isFiveSchemesDialogVisible: boolean
}

export default function FiveSchemeErrorMessage({ handleCloseFiveSchemesDialog, isFiveSchemesDialogVisible }: Props) {
    return (
        <Dialog
            onClose={handleCloseFiveSchemesDialog}
            open={isFiveSchemesDialogVisible}
            maxWidth='sm'
            sx={(theme: Theme) => ({
                '& .MuiPaper-root': {
                    borderRadius: '12px',
                    backgroundColor: theme.palette.common.white,
                    padding: "24px",
                    width: "533px",
                },
            })}
        >
            <Box
                sx={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                    alignItems: "center",
                    rowGap: "48px"
                }}
            >
                <Box
                    sx={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "center",
                        alignItems: "center",
                        rowGap: "14px",
                        paddingTop: "15px"
                    }}
                >
                    <Box
                        component="img"
                        src="/images/max-cart-items.svg"
                        alt="Max cart items"
                        sx={{ objectFit: "contain" }}
                    />
                    <Typography
                        variant="h2"
                        sx={(theme: Theme) => ({
                            lineHeight: "25px",
                            letterSpacing: "0.01px",
                            color: theme.palette.text.primary
                        })}
                    >
                        You can add only {MAX_SCHEMES_SELECTED} schemes at a time !
                    </Typography>
                    <Typography
                        variant="subtitle_400"
                        sx={(theme: Theme) => ({
                            lineHeight: "20px",
                            letterSpacing: "0.02px",
                            color: theme.palette.text.secondary
                        })}
                    >
                        Cart cannot contain more than {MAX_SCHEMES_SELECTED} schemes
                    </Typography>
                </Box>
                <Button
                    variant="contained"
                    fullWidth
                    sx={(theme: Theme) => ({
                        padding: "13px 20px",
                        borderRadius: "4px",
                        backgroundColor: theme.palette.primary[500],
                        fontWeight: 600,
                        fontSize: "16px",
                        lineHeight: "20px"
                    })}
                    onClick={handleCloseFiveSchemesDialog}
                >
                    Okay
                </Button>
            </Box>
        </Dialog>
    )
}